define(function (require) {

	//templates
	const tpl = require('./t_lov_map_toggle.hbs');

	//Utilities
	const view_manager = require('civicsUtils/view_manager');

/***************************************************************************************************** *
 * This absolutely doesn't need to be it's own view any more. When time allows, integrate it into the main LOV
/***************************************************************************************************** */
	return Marionette.LayoutView.extend({
		template: tpl,
		ui: {
			'mapToggle':'.map-toggle input'
		},
		events: {
			'change @ui.mapToggle':'toggled'
		},


		initialize: function (options) {
			this.mapStateName = options.mapStateName;
			this.parent = options.parent;
			var mapState = view_manager.getMapState('CIVICS', this.mapStateName);
			mapState = mapState === true || mapState === false ? mapState : true;
			this.model.set('mapToggle', mapState);
		},
		toggled: function (e) {
			e.preventDefault();
			e.stopPropagation();
			this.model.set('mapToggle', !this.model.get('mapToggle'));
			this.triggerMethod('map:toggled', this.model);
			view_manager.setMapState('CIVICS', this.mapStateName, this.model.get('mapToggle'));
		},
		templateHelpers: function () {
			
		}
	});
});